import BannerListPage from "@/features/articles/pages/BannerListPage";
import BannerPinPage from "@/features/articles/pages/BannerPinPage";
import ArticlePinPage from "@/features/articles/pages/ArticlePinPage";
import Article from "@/components/admin/view/article/Article";
import ArticleLayout from "@/components/admin/layout/ArticleLayout";
import ArticleList from "@/components/admin/view/article/ArticleList";
import ArticleCreate from "@/components/admin/view/article/ArticleCreate";
import Constant from "@/config/constant";
import ArticlePreview from "@/components/admin/view/article/ArticlePreview";

export const articlesRoutes = {
  path: "articles",
  component: ArticleLayout,
  children: [
    {
      path: "/",
      name: "Article",
      component: Article,
      meta: {
        breadcrumb: Constant.BREADCRUMB.PROJECT_SELECT
      },
      children: [
        {
          path: ":articleType/create",
          name: "ArticleCreate",
          component: ArticleCreate,
          meta: {
            breadcrumb: Constant.BREADCRUMB.PROJECT_SELECT
          }
        },
        {
          path: ":articleType/edit/:articleId",
          name: "ArticleDetail",
          component: ArticleCreate,
          meta: {
            breadcrumb: Constant.BREADCRUMB.PROJECT_SELECT
          }
        },

        {
          path: ":articleType",
          name: "ArticleList",
          component: ArticleList,
          meta: {
            breadcrumb: Constant.BREADCRUMB.PROJECT_SELECT
          },
          children: [
            {
              path: ":articleStatus",
              name: "ArticleListStatus",
              component: ArticleList
            }
          ]
        }
      ]
    }
  ]
};

export const bannerRoutes = {
  name: "BannerList",
  path: "articles/banners",
  component: BannerListPage
};

export const bannerPinnedRoutes = {
  path: "articles/banners/pin",
  name: "BannerPinnedPage",
  component: BannerPinPage
};

export const articlePinnedRoutes = {
  path: "articles/pin",
  name: "ArticlePinnedPage",
  component: ArticlePinPage
};

export const previewArticleRoutes = {
  path: "articles/preview/:articleId",
  name: "ArticlePreview",
  component: ArticlePreview
};
